<template>
  <div class="event-filter-group event-sidebar-section">
    <h3 class="event-sidebar-section__title">Filter by Category</h3>

    <ul class="event-filter-group__list">
      <li
        v-for="filter in activeFilters"
        :key="filter.id"
      >
        <CheckboxFilter :filter="filter" />
      </li>
    </ul>
  </div>
</template>

<script>
import CheckboxFilter from './CheckboxFilter'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'FilterGroup',

  components: {
    CheckboxFilter
  },

  computed: {
    ...mapState([
      'filters'
    ]),

    activeFilters () {
      return this.filters.filter(f => f.count > 0)
    }
  }
}
</script>
